/** Verified link officials use their own client; no account-member lookup can broaden roles. */
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { RoleRoute, type RolePageContext } from "@/auth/RoleRoute";
import { createDeskApi, type DeskCompetition } from "@/api/desk";
import { DeskPage } from "@/pages/Desk";
export function DeskRoute() {
  return (
    <RoleRoute roles={["head_judge", "chief_judge"]}>
      {(context) => <Desk key={context.principalKey} context={context} />}
    </RoleRoute>
  );
}
function Desk({ context }: { context: RolePageContext }) {
  const { competitionId = "" } = useParams();
  const client = useMemo(() => {
    const api = createDeskApi(competitionId, context.transport, context.getToken);
    if (!context.session) return api;
    const session = context.session;
    return {
      ...api,
      context: async () => {
        // Read actual event configuration through the link's authorized API. The
        // identity and role list still come exclusively from verified redemption.
        const competition = await context.transport.get<DeskCompetition>(
          `/api/competitions/${encodeURIComponent(competitionId)}`,
        );
        return {
          competition: { ...competition, timezone: session.timezone ?? competition.timezone },
          roles: session.roles,
        };
      },
    };
  }, [competitionId, context.transport, context.getToken, context.session]);
  return <DeskPage client={client} />;
}
